import { useEffect, useState } from "react";
import api from "../lib/api";
import VideoCard from "../components/VideoCard";
import { useAuth } from "../context/AuthContext";
import { askForPremium } from "../lib/askPremium";
import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";

export default function RecentlyPlayed() {
  const { user } = useAuth();
  const [videos, setVideos] = useState([]);
  const isStandard = user && !user.is_premium && user.role !== "admin";

  useEffect(() => {
    if (!user) return;
    if (isStandard) { askForPremium("Recently Played is a premium feature"); return; }
    api.get("/recently-played").then((r) => setVideos(r.data)).catch(() => {});
  }, [user, isStandard]);

  if (!user) return (
    <div className="py-20 text-center">
      <h1 className="font-display text-3xl mb-3">Sign in to see recently played</h1>
      <Link to="/login" className="text-cyan-400 hover:underline">Log in</Link>
    </div>
  );

  if (isStandard) return (
    <div className="py-20 text-center" data-testid="recent-premium-gate">
      <Sparkles className="w-10 h-10 text-amber-400 mx-auto mb-3" />
      <h1 className="font-display text-3xl mb-3">Recently Played is a premium feature</h1>
      <p className="text-zinc-400 mb-6">Upgrade to see your listening history and pick up where you left off.</p>
      <Link to="/account" className="inline-block px-5 py-2.5 rounded-full bg-cyan-400 text-black font-semibold hover:bg-cyan-300">Upgrade to Premium</Link>
    </div>
  );

  return (
    <div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold mb-8">Recently Played</h1>
      {!videos.length && <div className="text-zinc-500 py-20 text-center">Nothing here yet — start playing something.</div>}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
        {videos.map((v) => <VideoCard key={v.id} video={v} size="sm" queue={videos} />)}
      </div>
    </div>
  );
}
